module.exports = __webpack_public_path__ + "static/media/10x_logo.860b3c09.png";